import InputMask from "react-input-mask";
import { Grid, TextField } from "@mzc-pdc/ui";
import React from "react";

const DurationField = ({ id, value, disabled, onChange, formatChars, mask, placeholder }) => {
    return (
        <Grid container flexDirection={"row"}>
            <InputMask
                className={"input-group-time"}
                disabled={disabled}
                formatChars={formatChars}
                mask={placeholder}
                placeholder={placeholder}
                value={value[`start`]}
                onChange={(e) => {
                    onChange(`start${id}`, e.target.value);
                }}
                onBlur={() => {
                    if (value[`start`] === mask) {
                        onChange(`start${id}`, "");
                    }
                }}
            >
                {(props) => <TextField sx={{ flexGrow: 1 }} placeholder={props.placeholder} />}
            </InputMask>
            <InputMask
                className={"input-group-time"}
                disabled={disabled}
                formatChars={formatChars}
                mask={mask}
                placeholder={placeholder}
                value={value[`end`]}
                onChange={(e) => {
                    onChange(`end${id}`, e.target.value);
                }}
                onBlur={() => {
                    if (value[`end`] === mask) {
                        onChange(`end${id}`, "");
                    }
                }}
            >
                {(props) => <TextField sx={{ marginLeft: "10px", flexGrow: 1 }} placeholder={props.placeholder} />}
            </InputMask>
        </Grid>
    );
};

export default DurationField;
